import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'

type Props = {
  order: App.Order
  showOrderId?: boolean
  orderItemType: 'offer' | 'tour'
}

const BookingIdConfirmation = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

function BookingsDetails(props: Props) {
  const intl = useIntl()
  const { order, showOrderId = true, orderItemType } = props

  let bookingIds: Array<string>
  if (orderItemType === 'tour') {
    bookingIds = order.tourItems.map((item) => item.bookingId) ?? []
  } else {
    bookingIds = order.items.map((item) => item.bookingNumber) ?? []
  }

  const bookingIdLabel = intl.formatMessage(
    {
      id: 'cKD6Js/wI2',
      defaultMessage: '{count, plural, one {Booking ID} other {Booking IDs}}',
      description: 'Heading for booking ID section, pluralized based on number of bookings',
    },
    { count: bookingIds.length },
  )

  const yourBookingDetailsLabel = intl.formatMessage({
    id: 'sneMnv4bdB',
    defaultMessage: 'Your Booking Details',
    description: 'Heading for the booking details section in trip item summary',
  })

  const totalPaidLabel = intl.formatMessage({
    id: 'gLQ33nDemQ',
    defaultMessage: 'Total Paid',
    description: 'Label for total amount paid in booking details',
  })

  return (
    <>
      <Heading variant="heading5">{yourBookingDetailsLabel}</Heading>
      {showOrderId && (
        <BookingIdConfirmation>
          <div>
            <BodyText variant="medium" weight="bold">
              {bookingIdLabel}
            </BodyText>
            <BodyText variant="large">{bookingIds.join(', ')}</BodyText>
          </div>
        </BookingIdConfirmation>
      )}
      <div>
        <BodyText variant="medium" weight="bold">
          {totalPaidLabel}
        </BodyText>
        <BodyText variant="large">${order.total}</BodyText>
      </div>
    </>
  )
}

export default BookingsDetails
